import { ISessionProps } from "../main/components/IProgress";

const isProd = false; // changes to register logs temporarily
const afdj_serverless_Endpoint =
  "ghyc5vmdyyed6i3addfrueoqem0nsgws.lambda-url.eu-west-1.on.aws";
const get_req_test_Endpoint =
  "6njpg6xs6zcvbkgmj4hftokkai0rgvra.lambda-url.eu-west-1.on.aws";
const api_endpoint = isProd ? afdj_serverless_Endpoint : get_req_test_Endpoint;

// const migrationAPIStaging = "d3qu2dl0qr2ltn.cloudfront.net/dj"; // staging
const migrationAPI = "d3pj7rgy9x9rhn.cloudfront.net/dj";

export function updateProgressState(newState: ISessionProps) {
  // not sending state to the server without AppID
  if (!newState.appID) return;

  // console.log("newState", newState);

  const url = `https://${api_endpoint}/updateProgress`;
  const options = {
    method: "POST",
    body: JSON.stringify(newState),
    headers: {
      "Content-Type": "application/json",
    },
  };

  fetch(url, options)
    .then((res) => res.json())
    .then((res) => console.log("updateState", res))
    .catch((err) => console.error(err));
}

export interface Feedback {
  usefulValue: string;
  easyValue: string;
  feedbackValue: string;
  emailValue: string;
}

export function sendFeedback(feedbackForm: Feedback, newState: ISessionProps) {
  // not sending state to the server without AppID

  const url = `https://${api_endpoint}/sendFeedback`;
  const options = {
    method: "POST",
    body: JSON.stringify({
      state: newState,
      feedback: feedbackForm,
      feedbackTime: new Date(),
    }),
    headers: {
      "Content-Type": "application/json",
    },
  };

  fetch(url, options)
    .then((res) => res.json())
    .then((res) => console.log("sendFeedback", res))
    .catch((err) => console.error(err));
}

export function getGCD(device_id: string, devkey?: string, appID?: string) {
  if (!devkey || !appID) {
    const lsAppId = localStorage.getItem("appId");
    if (lsAppId) {
      appID = JSON.parse(lsAppId);
    } else return null;

    const lsDevKey = localStorage.getItem("devKey");
    if (lsDevKey) {
      devkey = JSON.parse(lsDevKey);
    } else return null;
  }

  const url = `https://${api_endpoint}/getGCD`;
  const options = {
    method: "POST",
    body: JSON.stringify({
      appID,
      devkey,
      device_id,
    }),
    ccredentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetch(url, options).then((res) => res.json());
}

export function testConsoleRegister(
  appID: string,
  device_id: string,
  device_id_type: string,
  device_name: string,
  token: string
) {
  const url = `https://${api_endpoint}/testconsole/register`;

  const options = {
    method: "POST",
    body: JSON.stringify({
      appID,
      device_id,
      device_id_type,
      device_name,
      token,
    }),
    ccredentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  };
  console.log("Trying to Register Device with token:", token);
  console.log("Trying to Register Device with appID:", appID);
  console.log("Trying to Register Device with device_id:", device_id);

  return fetch(url, options).then((res) => res.json());
}

const useMockTestConsoleEvents = false; // change to true if you want to test events locally

export function testConsoleEvents(
  appID: string,
  device_id: string,
  token: string
) {
  console.log("Using token:", token);
  console.log("Using appID:", appID);
  console.log("Using device_id:", device_id);
  const url = `https://${api_endpoint}/testconsole/events`;
  const date = new Date();
  date.setMinutes(date.getMinutes() - 5); // get results from the last 5 minutes
  const start_time = date.toISOString();
  const options = {
    method: "POST",
    body: JSON.stringify({
      appID,
      device_id,
      token,
      start_time,
    }),
    ccredentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  };

  console.log("data sent to API: ", options.body);
  if (useMockTestConsoleEvents) {
    console.log("DEBUG: Returning MOCK testConsoleEvents response");

    // <<<< RETURN PREDEFINED MOCK DATA
    const mockResponse = {
      status: "Success",
      data: {
        message: "Mocked events received",
        data: [
          {
            timestamp_sdk: "2025-04-27T14:14:44Z",
            event_type: "In-App",
            appsflyer_id: "1745763207998-1089892254653512701",
            event_name: "af_add_to_cart",
            event_value: JSON.stringify({
              af_currency: "USD",
              af_revenue: 1.5,
              af_price: 10,
              af_search_string: "Test Search query",
              af_content_id: "myprod/1234",
              af_coupon_code: "Coupon Code",
              af_quantity: 6,
              af_description: "Customer added item to cart",
            }),
            sdk_version: "6.14.0",
            app_version: "1.0",
            customer_user_id: null,
            idfa: null,
            idfv: null,
            gaid: "38c3d97f-3387-4aa3-b32c-51ce841fc0a6",
            android_id: null,
            imei: null,
            oaid: null,
            amazon_aid: null,
            af_deeplink: null,
          },
          {
            timestamp_sdk: "2025-04-27T14:14:44Z",
            event_type: "In-App",
            appsflyer_id: "1745763207998-1089892254653512701",
            event_name: "af_purchase",
            event_value: JSON.stringify({
              af_currency: "USD",
              af_revenue: 51.98,
              af_price: 25.99,
              af_content_id: "myprod/5678",
              af_coupon_code: "DISCOUNT10",
              af_quantity: 2,
              af_description: "Customer completed a purchase",
              // Note: no af_search_string here
            }),
            sdk_version: "6.14.0",
            app_version: "1.0",
            customer_user_id: null,
            idfa: null,
            idfv: null,
            gaid: "38c3d97f-3387-4aa3-b32c-51ce841fc0a6",
            android_id: null,
            imei: null,
            oaid: null,
            amazon_aid: null,
            af_deeplink: null,
          },
          {
            timestamp_sdk: new Date().toISOString(),
            event_type: "Ad Revenue",
            appsflyer_id: "mock-af-id",
            event_name: "af_ad_revenue",
            event_value: JSON.stringify({
              monetization_network: "mock_network",
              mediation_network: "applovinmax",
              event_revenue_currency: "USD",
              event_revenue: 2,
              ad_unit: "mock_ad_unit",
              ad_type: "rewarded",
              placement: "mock_placement",
              custom_parameters: {
                hi: "there",
              },
            }),
            sdk_version: "v6.16.0",
            app_version: "1.0",
            customer_user_id: null,
            idfa: null,
            idfv: null,
            gaid: device_id,
            android_id: null,
            imei: null,
            oaid: null,
            amazon_aid: null,
            af_deeplink: null,
          },
        ],
      },
    };

    return Promise.resolve(mockResponse);
  }

  return fetch(url, options).then((res) => res.json());
}

export function testConsoleOnelinkSig(
  devKey: string,
  oneLinkId: string,
  shortLinkId: string
) {
  const url = `https://${api_endpoint}/testconsole/onelinksig`;
  const options = {
    method: "POST",
    body: JSON.stringify({
      devKey,
      oneLinkId,
      shortLinkId,
    }),
    ccredentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetch(url, options).then((res) => res.json());
}

export function getApiVer() {
  const url = `https://${api_endpoint}/getApiVer`;
  const options = {
    method: "GET",
    ccredentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetch(url, options).then((res) => res.json());
}

export function translateCode(code: string, promptType: string) {
  const url = `https://${migrationAPI}/generate`;
  const options = {
    method: "POST",
    ccredentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ code, promptType }),
  };

  return fetch(url, options).then((res) => res.json());
}

export async function migrationAllowList(appId: string) {
  const baseURL = `https://${migrationAPI}/validate`;
  const params = {
    app_id: appId,
  };

  const url = new URL(baseURL);
  url.search = new URLSearchParams(params).toString();

  const options = {
    method: "GET",
    ccredentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  };
  const result = await fetch(url, options);
  return result.json();
}
